import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { firstValueFrom, Subject } from 'rxjs';
import { RecoveryService } from 'src/app/domain/recovery/service/recovery.service';
import { ModalButtons, SpinnerProps } from 'src/app/domain/shared/component/modal-container/modal-container.component';

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss'],
})
export class ModalDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  private _destroyStream: Subject<void> = new Subject<void>();
  @Input() header: string;
  @Input() subtitle: string;
  @Input() greenTitle;
  @Input() innerModal = false;
  @Input() showConfirm = true;
  @Input() isSecurityProtection = false;
  @Input() mainText: string[];
  @Input() contentDirection: 'centered' | 'start' = 'start';
  @Input() titleDirection: 'centered' | 'start' = 'start';
  @Input() addAdditionalText = false;
  @Input() showIUnderstand = true;
  @Input() hideAllText = false;
  @Input() showDescription = false;
  @Input() textForDescription: string = null;
  // show or hide div as whitespace
  @Input() showWhiteSpace = true;
  // if true standard text list would be displayed
  @Input() useStandardList = true;
  // show or hide text input
  @Input() showInput = true;

  @Output() isConfirmed: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() isItSecurity = false;
  @Input() isLogin = false;
  @Input() isRecovery = false;
  @Input() modalButtons: ModalButtons;
  @ViewChild('input') focus: ElementRef;

  spinnerProps: SpinnerProps = {
    isSpinnerActive: false,
    notActiveOnApply: true,
  };

  THINK_TWICE = 'thinktwice';

  isPasswordInvalid = false;
  password: string;

  constructor(private recoveryService: RecoveryService) {}


  close(): void {
    this.isConfirmed.emit(false);
  }

  ngOnInit(): void {
    this.password = '';
    if (this.isLogin) {
      return;
    }
    if (!this.modalButtons) {
      this.modalButtons = {
        dismiss: 'Cancel',
        apply: 'Delete',
      };
    };
    if (this.addAdditionalText) {
      this.mainText = this.mainText.concat(standardTextListForModalDelete);
    }
    if (!this.showInput) {
      this.password = this.THINK_TWICE;
    }
    // for old ver if description added it would be concat with standard text list
    if (!this.mainText?.length) {
      this.mainText = [].concat(standardTextListForModalDelete);
    }
    if (this.hideAllText) {
      this.mainText = undefined;
    }
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  ngAfterViewInit(): void {
    this.focus?.nativeElement?.focus();
  }

  confirmCheckingPassword(): void {
    // security check for access to recovery
    if (this.isSecurityProtection) {
      this.checkPasswordForSecurity();
      return;
    }
    // regular check for
    this.checkThinkTwicePassword();
  }

  async checkPasswordForSecurity(): Promise<void> {
    const isPasswordValid = await this.checkUserPassword();
    if (isPasswordValid) {
      this.isConfirmed.emit(true);
      return;
    }
    this.isPasswordInvalid = true;
  }

  private checkThinkTwicePassword(): void {
    if (this.password === 'thinktwice') {
      this.isConfirmed.emit(true);
    } else {
      this.isPasswordInvalid = true;
    }
  }

  private async checkUserPassword(): Promise<boolean> {
    return firstValueFrom(this.recoveryService.checkUserPassword(this.password));
  }
}

const standardTextListForModalDelete = ['Everyone will lose this and underlying data', 'This can not be undone'];
